export default {
  MULTI_ACCOUNT_MANAGER: 100,
  ACCOUNT_MANAGER: 80,
  AGENCY_MANAGER: 60,
  CAMPAIGN_MANAGER: 40,
  DATA_COLLECTOR: 20,
  VISITOR: 0,
};
